import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, MenuItem, TextField } from '@mui/material';
import { useSubscriptionStatus } from '../useSubscriptionStatus';
import SubscriptionGuard from '../SubscriptionGuard';
import CoreBaseCore from './CoreBaseCore';
import CoreBaseLandingPage from './CoreBaseLandingPage';
import { coreBaseApi, setCrmWorkspace } from './services/coreBaseApi';
import { useAuthStore } from '../../store/authStore';

export default function CoreBaseApp() {
  const subscription = useSubscriptionStatus('corebase_crm_v1');
  const userId = useAuthStore(state => state.user?._id);
  const [spaces, setSpaces] = useState(null);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(false);
  const [spacesUserId, setSpacesUserId] = useState(null);
  useEffect(() => {
    setSpaces(null); setSelected(null); setError(false);
    if (!userId || !localStorage.getItem('token')) { setSpaces([]); setCrmWorkspace(null); return; }
    let cancelled = false;
    coreBaseApi.workspaces().then(data => {
      if (cancelled) return;
      const available = data.workspaces;
      const initial = available.find(s => s.active) || available[0];
      setCrmWorkspace(initial?.id);
      setSelected(initial?.id);
      setSpaces(available);
      setSpacesUserId(userId);
    }).catch(() => { if (!cancelled) { setError(true); setSpaces([]); } });
    return () => { cancelled = true; };
  }, [userId]);
  if (!userId) return <CoreBaseLandingPage />;
  if (spacesUserId !== userId && !error) return <Box p={3}><CircularProgress size={24} /></Box>;
  if (!spaces) return <Box p={3}><CircularProgress size={24} /></Box>;
  if (error) return <Alert severity="error">No se pudieron cargar los espacios CRM. Recarga la pagina.</Alert>;
  const workspace = spaces.find(s => s.id === selected);
  const content = <>
    {spaces.filter(s => s.active).length > 1 && <Box sx={{ width: '100%', mb: 2 }}>
      <TextField label="Espacio CRM" select size="small" value={selected} onChange={e => { setCrmWorkspace(e.target.value); setSelected(e.target.value); }}>
        {spaces.filter(s => s.active).map(s => <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>)}
      </TextField>
    </Box>}
    {workspace && <CoreBaseCore key={workspace.id} workspace={workspace} />}
  </>;
  if (workspace && !workspace.isOwner && workspace.active) return content;
  return <SubscriptionGuard {...subscription} landing={<CoreBaseLandingPage />} appKey="corebase_crm_v1" appName="CoreBase CRM">{content}</SubscriptionGuard>;
}
